module.exports = __webpack_public_path__ + "static/media/excel.f18da4d7.svg";